import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetMemberPasswordMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  newPassword?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResetMemberPasswordMutation = { __typename?: 'Mutation', resetMemberPassword: boolean };


export const ResetMemberPasswordDocument = gql`
    mutation ResetMemberPassword($id: ID!, $newPassword: String) {
  resetMemberPassword(id: $id, newPassword: $newPassword)
}
    `;
export type ResetMemberPasswordMutationFn = Apollo.MutationFunction<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>;

/**
 * __useResetMemberPasswordMutation__
 *
 * To run a mutation, you first call `useResetMemberPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMemberPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMemberPasswordMutation, { data, loading, error }] = useResetMemberPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetMemberPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>(ResetMemberPasswordDocument, options);
      }
export type ResetMemberPasswordMutationHookResult = ReturnType<typeof useResetMemberPasswordMutation>;
export type ResetMemberPasswordMutationResult = Apollo.MutationResult<ResetMemberPasswordMutation>;
export type ResetMemberPasswordMutationOptions = Apollo.BaseMutationOptions<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>;